import { match, P } from 'ts-pattern'
import type { Tag } from 'src/services/apollo/generated/graphql'

export function createTagPageUrl(type: 'artwork' | 'model', tagName: string) {
  const encodedTagName = encodeURIComponent(tagName)
  return match(type)
    .with('artwork', () => `/tags/artwork/${encodedTagName}`)
    .with('model', () => `/tags/model/${encodedTagName}`)
    .exhaustive()
}

export const TagCategory = {
  Contest: 'contest',
  Category: 'category',
  Feature: 'feature',
  Other: 'other',
} as const

/**
 * Picked Tag fields for display
 */
export type TagItem = Pick<
  Tag,
  'id' | 'name' | 'displayName' | 'extra' | 'mediaId'
>

export type DetailedTag = {
  name: string
  tag: TagItem
  contest?: {
    contestId: number
    darkAccentColor: string
    lightAccentColor: string
  }
}

export const getTagName = (tag: Pick<Tag, 'name' | 'displayName'>) => {
  return getTagDisplayName(tag)
}

export const getTagDisplayName = (tag: Pick<Tag, 'name' | 'displayName'>) => {
  return tag.displayName ?? tag.name
}

export const getTagCategory = (tag: Pick<Tag, 'extra'>) => {
  const recommendType = tag.extra?.recommendType || tag.extra?.category
  return (
    match(recommendType)
      // category tag
      .with(P.union('style', 'ip', 'character'), () => TagCategory.Category)
      // feature tag
      .with('feature', () => TagCategory.Feature)
      // contest tag
      .with('contest', () => TagCategory.Contest)
      // other tag
      .otherwise(() => TagCategory.Other)
  )
}
